module.exports = __webpack_public_path__ + "static/media/staircase.5baf35c7.JPG";